import React from 'react';
import Select from 'react-select';
import { SORT_TYPES } from 'src/components/Sorting/constants';
import type { Field, Order } from 'src/components/Sorting/types';
import CustomControl from './components/CustomControl';
import CustomSingleValue from './components/CustomSingleValue';
import CustomOption from './components/CustomOption';

const customStyles = {
  control: () => ({
    cursor: 'pointer',
    border: 'none',
  }),
  option: () => ({}),
  menu: (baseStyles) => ({ ...baseStyles, width: '272px' }),
  menuList: (baseStyles) => ({
    ...baseStyles,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

type Props = {
  field: Field;
  order: Order;
  changeSorting: ({ field, order }: { field: Field; order: Order }) => void;
};

export type SortOption = {
  id: Field;
  order: Order;
  label: string;
  categoryLabel: string;
  selected: boolean;
};

/**
 * Трансформер данных из SORT_TYPES в опшены для селекта из react-select
 */
const getOptionList = (selectedField: Field, selectedOrder: Order) => {
  const res: SortOption[] = [];

  SORT_TYPES.forEach((sort) => {
    sort.types.forEach((type) => {
      res.push({
        id: sort.id, // Поле, по которому сортируем
        order: type.order, // Порядок - по возрастанию или по убыванию
        categoryLabel: sort.label, // Лейбл для отображения поля, по которому сортируем (например, "По цене")
        label: type.label, // Лейбл с учетом порядка сортировки (например, "Сначала дешевые" или "Сначала дорогие")
        selected:
          sort.id === selectedField &&
          (type.order === null || type.order === selectedOrder),
      });
    });
  });

  return res;
};

const CollapsedSelect = ({ field, changeSorting, order }: Props) => {
  const options = getOptionList(field, order);

  const handleChange = (option) => {
    changeSorting({ field: option.id, order: option.order });
  };

  return (
    <Select
      value={options.find((option) => option.selected)}
      onChange={handleChange}
      styles={customStyles}
      isSearchable={false}
      components={{
        IndicatorSeparator: () => null,
        Control: CustomControl,
        SingleValue: CustomSingleValue,
        Option: CustomOption,
      }}
      options={options}
    />
  );
};

export default CollapsedSelect;
